/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `exercise_title` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class ExerciseTitleMesg : Mesg {
    public constructor() : super("ExerciseTitle", Profile.MesgNum.EXERCISE_TITLE)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** message_index. */
    public var messageIndex: UShort?
        get() = getFieldValue(MESSAGE_INDEX_FIELD_NUM) as? UShort
        set(value) = setFieldValue(MESSAGE_INDEX_FIELD_NUM, value)

    /** exercise_category. */
    public var exerciseCategory: ExerciseCategory?
        get() = (getFieldValue(EXERCISE_CATEGORY_FIELD_NUM) as? UShort)?.let { ExerciseCategory.fromValue(it) }
        set(value) = setFieldValue(EXERCISE_CATEGORY_FIELD_NUM, value?.value)

    /** exercise_name. */
    public var exerciseName: UShort?
        get() = getFieldValue(EXERCISE_NAME_FIELD_NUM) as? UShort
        set(value) = setFieldValue(EXERCISE_NAME_FIELD_NUM, value)

    /** Number of values stored in wkt_step_name. */
    public val numWktStepName: Int
        get() = getField(WKT_STEP_NAME_FIELD_NUM)?.numValues ?: 0

    /** wkt_step_name. */
    public var wktStepName: List<String?>?
        get() {
            val field = getField(WKT_STEP_NAME_FIELD_NUM) ?: return null
            return List(field.numValues) { getWktStepName(it) }
        }
        set(value) {
            removeField(WKT_STEP_NAME_FIELD_NUM)
            value?.forEachIndexed { index, element -> setWktStepName(index, element) }
        }

    public fun getWktStepName(index: Int): String? =
        getFieldValue(WKT_STEP_NAME_FIELD_NUM, index) as? String

    public fun setWktStepName(index: Int, value: String?) {
        setFieldValue(WKT_STEP_NAME_FIELD_NUM, value, index)
    }

    public companion object {
        public const val MESSAGE_INDEX_FIELD_NUM: UByte = 254u
        public const val EXERCISE_CATEGORY_FIELD_NUM: UByte = 0u
        public const val EXERCISE_NAME_FIELD_NUM: UByte = 1u
        public const val WKT_STEP_NAME_FIELD_NUM: UByte = 2u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[254] = Field("MessageIndex", 254u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[0] = Field("ExerciseCategory", 0u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[1] = Field("ExerciseName", 1u, BaseType.UINT16, 1.0, 0.0, "", false)
            fields[2] = Field("WktStepName", 2u, BaseType.STRING, 1.0, 0.0, "", false)
            return fields
        }
    }
}
